module.exports = __webpack_public_path__ + "fonts/deposit-detail-guide-1.a74dbc00s.png";